import React, { Suspense, useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import qs from "qs";
import { useLazyQuery } from "@apollo/react-hooks";

import { CircularProgressCustom } from "../CircularProgressCustom";
import MainContext from "../../../../context/Main";

import CollectionInfoTable from "./CollectionInfoTable";
import QuickView from "./QuickView";
import RelatedProducts from "./RelatedProducts";
import OrderingGuideTable from "./OrderingGuideTable";
import AboutSection from "./AboutSection";
import FeaturesBenefits from "./FeaturesBenefits";
import { GET_COLLECTION_ID } from "../../../../services/graphql-query";

export default function CollectionPage() {
    const { totalProducts } = useContext(MainContext);

    const params = useParams();
    const { state } = useLocation();

    const [collectionId, setCollectionId] = useState(state && state.id);
    const [isSetId, setIsSetId] = useState(false);

    const [getId, { loading, error, data }] = useLazyQuery(GET_COLLECTION_ID, {
        variables: { name: params.collectionName },
        onCompleted: (res) => {
            if (res.collections.data[0]?.id)
                setCollectionId(res.collections.data[0].id);
            setIsSetId(true);
        },
    });
    useEffect(() => {
        if (collectionId) {
            setIsSetId(true);
        } else {
            getId();
        }
    }, [collectionId]);

    if (isSetId && !collectionId)
        return (
            <div className="text-center">
                <h2 className="mb-3">
                    There doesn't seem to be such a collection
                </h2>
                <p className="lead">
                    {" "}
                    Try to enter the '{params.collectionName}' in the search
                </p>
            </div>
        );
    if (isSetId && collectionId)
        return (
            <>
                <QuickView collectionId={collectionId} />

                <CollectionInfoTable />

                <Suspense
                    fallback={
                        <h1>Please, wait. Ordering guide is loading...</h1>
                    }
                >
                    <OrderingGuideTable
                        collectionName={params.collectionName}
                    />
                </Suspense>

                <AboutSection collectionName={params.collectionName} />
                <FeaturesBenefits collectionName={params.collectionName} />

                {totalProducts && (
                    <RelatedProducts
                        totalProducts={totalProducts}
                        collectionId={collectionId}
                    />
                )}
            </>
        );

    return <CircularProgressCustom />;
}
